<template>
  <div class="p-2">
    <p class="lead text-center">{{ eventData.device.name }}</p>
    <table class="table">
      <tr>
        <th>{{ $t('intelbras.event_id') }}</th>
        <td>{{ eventData.alarm.event_id }}</td>
      </tr>
      <tr>
        <th>{{ $t('intelbras.event') }}</th>
        <td>{{ eventData.alarm.code }} - {{ eventData.alarm.description }}</td>
      </tr>
      <template v-if="!eventData.alarm.partition">
        <tr>
          <th>{{ $t('intelbras.zone') }}</th>
          <td>{{ eventData.alarm.zone }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <th>{{ $t('intelbras.pgm_output') }}</th>
          <td>{{ eventData.alarm.partition }}</td>
        </tr>
      </template>
      <template>
        <tr>
          <th>{{ $t('intelbras.name') }}</th>
          <td>{{ eventData.alarm.device_alias }}</td>
        </tr>
      </template>
      <tr>
        <th>{{ $t('intelbras.panel_model') }}</th>
        <td>{{ eventData.alarm.panel_model }}</td>
      </tr>
      <tr>
        <th>{{ $t('intelbras.date') }}</th>
        <td>{{ formattedDate }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "@/libs/axios";
import moment from "moment";

export default {
  name: "intelbras-event-data",
  props: {
    eventData: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    formattedDate() {

      return moment
        .tz(this.eventData.alarm.event_created_at, 'UTC')
        .tz(this.eventData.alarm.time_zone)
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
}
</script>


<style scoped lang="scss">

</style>
